import * as React from "react";
import styled from "styled-components";
import { UserProfile } from "./UserProfile";
import { IconButton, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SitemarkIcon from '../SitemarkIcon';

export default function TopBar({ user, toggleMobileMenu }) {
  return (
    <HeaderWrapper>
      {/* Bouton Menu Mobile */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" }, // Visible uniquement sur mobile
          alignItems: "center",
          marginRight: "16px",
        }}
      >
        <IconButton onClick={toggleMobileMenu} sx={{ color: "primary.main" }}>
          <MenuIcon />
        </IconButton>
      </Box>

      {/* Section principale */}
      <MainSection>
        <SitemarkIcon/>
      </MainSection>

      {/* Profil utilisateur */}
      <UserProfileContainer>
        <UserProfile user={user} />
      </UserProfileContainer>
    </HeaderWrapper>
  );
}

const HeaderWrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0 16px;
  font-family: Roboto, sans-serif;
`;

const MainSection = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: left;
`;

const UserProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto; /* Pousse le profil utilisateur à l'extrémité droite */
`;